<template>
  <div class="container">
    <div class="loader">
      <div v-show="value>0" class="content" :style="`right: calc(${100 - value}% - 2px)`"></div>
    </div>
<!--    <div class="progress-6" />-->
    <div class="progress-text text--bold">
      {{`${value}% Complete`}}
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressLinear",
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/SelfService/spacing.scss';
@import "~@/styles/SelfService/typography.scss";
@import "~@/styles/SelfService/colors.scss";

.container {
  padding: $spacing--s;
}

.loader{
  height: 15px;
  position: relative;

  background: white;
  border: 2px solid #000000;
  -moz-box-sizing:border-box;
  -webkit-box-sizing:border-box;
  box-sizing: border-box;
  border-radius: 10px;

  .content {
    height: inherit;
    position: absolute;
    left: -2px;
    top: -2px;
    right: 100%;

    background: $brand-1;
    border: 2px solid #000000;
    -moz-box-sizing:border-box;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    border-radius: 10px;

    transition:right 0.3s linear;
  }
}

.progress-text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: $font-size--s;
  padding-top: $spacing--xs;
}
</style>
